import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const StarredAttributeIcon = (props: IconProps) => (
  <Icon width="17px" height="16px" viewBox="0 0 17 16" {...props}>
    <path d="m15.0319 6.15998-4.7934-.41333-1.87329-4.41334-1.87333 4.42-4.79333.40667 3.64 3.15333L4.24521 14l4.12-2.4867L12.4852 14l-1.0867-4.68669 3.6334-3.15333ZM8.36521 10.2666 5.85855 11.78l.66666-2.85335-2.21333-1.92 2.92-.25334 1.13333-2.68666 1.14 2.69333 2.91999.25333-2.2133 1.92.6666 2.85329-2.51329-1.52Z" />
  </Icon>
);

export default memo(StarredAttributeIcon);
